import React,{useState,useEffect} from 'react';
import { Row, Col} from 'react-bootstrap';
import { Navbar, Nav, Form, Container,Button, FormControl, Accordion, Badge} from 'react-bootstrap';
import { Image} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThLarge, faTh, faSearch, faAlignJustify } from '@fortawesome/free-solid-svg-icons';
import Card from './card';
import { isBrowser, isMobileSafari, isMobile, isIOS } from 'react-device-detect';
import { useLanguage } from '../i18n/LanguageContext';

function Cards(props){
  const { t } = useLanguage();
  const [currentCard, setCard] = useState("0");
  const [cols, setCols] = useState("4");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);
  var myRef = React.createRef();

  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }

    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
    
  },[]);

  var txtFind;
  var textInput = React.createRef(); 

  function getCardsLayout(){
    if (cols == "type"){
      return getCategories();
    }
    else{
      return getCards(parseInt(cols));
    }
  }

  function getCatergoryCards(cards){
    var cardItems = cards.map(function(c){
    var cardPath = "cards/" + c.toString() + ".jpg";
    var className = "";
    if (cards.length == 12 || cards.length == 28){
      className = "col-3"
    }
    return (
        <div className={className} style={{padding:'1px'}} onClick={handleClick.bind(this,c)}><Image alt={c} src={cardPath} thumbnail style={{width: 'min(22vw,190px)', height:'min(calc(22vw*1.3), calc(190px*1.3)'}} /></div>
        );
    });

    return cardItems
  }

  function getCategories(){
    //categories:
    var categories = [];
    categories["Founders"] = {color:"#A4317A",cards:[1]};
    categories["Arcturus"] = {color:"#E887AC",cards:[7,8,9,10]};
    categories["Andromeda"] = {color:"#C2B8D6",cards:[3,4,5,6]};
    categories["Lyra"] =  {color:"#F8DE0D",cards:[11,12,13,14,15,16,17,18,67,68,69,70]};
    categories["Vega"] = {color:"#89402E",cards:[19,20,21,22,23,24,25,26,71,72,73,74]};
    categories["Orion & Orion Light"] = {color:"#E86A2B",cards:[35,36,37,38,55,56,57,58,105,106,107,108]};
    categories["Pleiades"] =  {color:"#99D7CB",cards:[39,40,41,42,63,64,65,66,86,87,88,89]};
    categories["Sirius"] = {color:"#E5DD85",cards:[43,44,45,46,59,60,61,62,92,93,94,95]};
    categories["Zeta Reticuli"] = {color:"#798B88",cards:[30,31,32,33,79,80,81,82,97,98,99,100]};
    categories["Earth"] = {color:"#2793C1",cards:[47,48,49,50,51,52,53,54,75,76,77,78]};
    categories["Essassani"] = {color:"#D20B5D",cards:[101,102,103,104]};
    categories["Cetacean Dolphin & Whale"] = {color:"#4CC6C9",cards:[84,85,90,91]};
    categories["Hybrid"] = {color:"#5D77AB",cards:[83]};
    categories["Reptilian"] = {color:"#C9C61E",cards:[28]};
    categories["Insectoid"] = {color:"#ABCC34",cards:[29]};
    categories["Non-humanoid"] = {color:"#512922",cards:[27]};
    categories["Solar System"] = {color:"#0AA279",cards:[34]};
    categories["Galactic Core"] = {color:"#000000",cards:[2]};
    categories["Association of Worlds"] =  {color:"#1898A4",cards:[96]};
    //Past,Present,Future,Parallel
    var timelines = [];
    timelines["Past"] = [11,12,13,14,19,20,21,22,30,31,32,33,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50];
    timelines["Present"] = [15,16,17,18,23,24,25,26,51,52,53,54,55,56,57,58,63,64,65,66,59,60,61,62,79,80,81,82];
    timelines["Future"] = [67,68,69,70,71,72,73,74,75,76,77,78,86,87,88,89,92,93,94,95,97,98,99,100,105,106,107,108];
    timelines["Parallel"] = [1,2,3,4,5,6,7,8,9,10,27,28,29,34,83,84,85,90,91,96,101,102,103,104];
  
    var accordianItems = [];
    for (var key in categories) {
      var cards = categories[key];
      accordianItems.push((<Accordion.Item eventKey={key}>
      <Accordion.Header><div className="d-flex flex-wrap justify-content-between" style={{width:'100%', paddingRight:'20px'}}>
                          <div className="d-flex flex-wrap justify-content-start">
                          <div style={{width:'20px', height:'20px', borderRadius: '50%', backgroundColor:`${cards.color}`}}/>
                            <div style={{paddingLeft:'10px'}}>{t('cards.categories.' + key, key)}</div>
                          </div>
                          <div><Badge bg="secondary">{cards.cards.length}</Badge></div>
                        </div>
      </Accordion.Header>
      <Accordion.Body>
        <div className="d-flex justify-content-center flex-wrap">
          {getCatergoryCards(cards.cards)}
        </div>
      </Accordion.Body></Accordion.Item>));
    }

    var timelineItems = [];
    for (var key in timelines) {
      var cards = timelines[key];
      timelineItems.push((<Accordion.Item eventKey={key}>
      <Accordion.Header><div className="d-flex flex-wrap justify-content-between" style={{width:'100%', paddingRight:'20px'}}><div>{t('cards.timelines.' + key, key)}</div><div><Badge bg="secondary">{cards.length}</Badge></div></div></Accordion.Header>
      <Accordion.Body>
        <div className="d-flex justify-content-center flex-wrap">
          {getCatergoryCards(cards)}
        </div>
      </Accordion.Body></Accordion.Item>));
    }

    var accHeight = '100vh';
    if (isBrowser || isMobileSafari){
      accHeight = height + 'px';
    }
  
    return (<div ref={myRef} style={{paddingTop:'75px',paddingBottom:'100px',overflow:'auto', height:'calc(' + accHeight + ' - 75px - env(safe-area-inset-top))'}}>
        <div style={{color:'lightgray', ontSize:'1.3em', padding:'15px'}}>{t('cards.fragments')}</div>
        <Accordion style={{width:width}} variant={props.theme}>{accordianItems}</Accordion>
        <div style={{color:'lightgray', ontSize:'1.3em', padding:'15px'}}>{t('cards.timeline')}</div>
        <Accordion style={{width:width}} variant={props.theme}>{timelineItems}</Accordion>
      </div>);
  }

  function getCards(count){
    var cards;
    var buffer = 200;
    var cHeight = '100vh';
    if (isBrowser || isMobileSafari || isIOS){
      cHeight = height + 'px';
      buffer = 240;
    }

    //full page
    if (count == 18){
      var grid = []
      var rows = 108/count;
      for(var r=1;r<=rows;r++){
        var h, w, row;
        if (width >= height){
          row = (<Row>{renderCols(count,(r-1)*count + 1)}</Row>);
        }
        else{
          h = (height - buffer)/6;
          w = h/1.28 * 18;
          row = (<Row style={{width:w}}>{renderCols(count,(r-1)*count + 1)}</Row>);
        }
        grid.push(row);
      }
     
      cards =  (
        <Container fluid style={{paddingTop:'calc(65px + 0.6vw)',paddingBottom:'80px', overflow:'auto',overflowY:'hidden', height:'calc(' + cHeight + ' - 75px - env(safe-area-inset-top))'}}>{grid}</Container>
      )
      
    }
    else{
      //flex
      var cardNos = []
      for(var c=1;c<=108;c++){
        cardNos.push(c);
      }
      cards = (<Container fluid className="semibackground" style={{padding:0}}>
        <div ref={myRef} className="d-flex justify-content-center flex-wrap" style={{paddingTop:'75px',paddingBottom:'95px', overflow:'auto', height:'calc(' + cHeight + ' - 75px - env(safe-area-inset-top))'}}>
          {getCatergoryCards(cardNos)}
        </div>
       </Container>)
    }


    return cards;
  }

  function renderCols(cols, start){
   
    var buffer = 200;
    if (isBrowser || isMobileSafari || isIOS){
      buffer = 240;
    }

    var columns = [];
    var style = {padding:0};
    var h, w;
    if (width >= height){
      w = width/18;
      h = w * 1.28;
      if (h * 6 > height - buffer){
        h = (height - buffer)/6;
        w = h/1.28;
      }
    }
    else{
      h = (height - buffer)/6;
      w = h/1.28;
    }
   
    if (cols == 18){
      style = {paddingLeft:0, paddingRight:0, overflow:'hidden', width:w, height:h};
    }
    for(var c=start;c<cols + start;c++){
      var cardPath = "cards/" + c.toString() + ".jpg";
      var card = (<Col style={style}><div onClick={handleClick.bind(this,c)}><Image className="img-thumbnail-min" alt={c} src={cardPath}/></div></Col>);
      columns.push(card);
    }
    return columns;
  }

  function handleSelect(cols){
    //window.scrollTo(0, 0);
    setCols(cols);
    props.onSubSelect();
  }

  function handleClick(key){
      setCard(key);
      handleShow(key);
      props.onSubSelect();
  }

  function handleFindClick(e){
    var key = textInput.current.value;
    if (parseInt(key)<= 108){
      setCard(key);
      handleShow(key);
      props.onSubSelect();
    }
    
}

var cHeight = '100vh';
if (isBrowser || isMobileSafari ){
  cHeight = height + 'px';
}

  return (
    <div>
      <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{width: "100%", paddingBottom:0, paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
        <Container>
        <Nav style={{width: "100%"}} className="justify-content-end" onSelect={handleSelect} defaultActiveKey="4">
          <Nav.Link eventKey="4"><FontAwesomeIcon icon={faThLarge}  size='2x' /></Nav.Link>
          <Nav.Link eventKey="type"><FontAwesomeIcon icon={faAlignJustify}  size='2x' /></Nav.Link>
          <Nav.Link eventKey="18"><FontAwesomeIcon icon={faTh}  size='2x' /></Nav.Link>
        </Nav>
        </Container>
        <Form className="d-flex" style={{marginRight: "10px"}}>
        <FormControl
          type="number"
          min={1}
          max={108}
          placeholder={t('cards.searchPlaceholder')}
          className="me-2"
          aria-label={t('common.search')}
          style={{width: "85px"}}
          ref={textInput}
        />
        <Button variant="secondary" onClick={handleFindClick}><FontAwesomeIcon icon={faSearch}  size='1x' /></Button>
      </Form>
      </Navbar>
        {getCardsLayout()}
      <Card card={currentCard} show={show} placement="bottom" name="bottom" onHide={handleClose} ></Card>
    </div>
  )
};

export default Cards;